import styled from "styled-components";
import Colors from "src/general/constants/colors";
import BreakPoints from "src/general/constants/breakPoints";

export const Content = styled.div`
	padding: 80px 60px 60px;
	background: ${Colors.WHITE};
	box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25), 0 8px 16px rgba(0, 0, 0, 0.2);
	border-radius: 24px;

	@media (min-width: ${BreakPoints.TABLETS}) and (max-width: ${BreakPoints.DESKTOPS}) {
		padding: 60px 40px 40px;
		width: 520px;
	}

	@media (max-width: ${BreakPoints.TABLETS}) {
		padding: 60px 40px 40px;
		width: 260px;
	}
`;

export const Title = styled.h1`
	font-weight: 600;
	font-size: 32px;
	line-height: 40px;
	color: ${Colors.BLACK_OLD};
	@media (min-width: ${BreakPoints.TABLETS}) and (max-width: ${BreakPoints.DESKTOPS}) {
		font-size: 24px;
		line-height: 30px;
	}
	@media (max-width: ${BreakPoints.TABLETS}) {
		font-size: 24px;
		line-height: 30px;
	}
`;

export const Description = styled.p`
	font-weight: 400;
	font-size: 20px;
	line-height: 30px;
	padding-top: 16px;
	color: ${Colors.BLACK_OLD};

	@media (max-width: ${BreakPoints.DESKTOPS}) {
		font-size: 16px;
		line-height: 24px;
		padding-top: 8px;
	}
`;

export const WrapperButtons = styled.div`
	display: flex;
	gap: 16px;
	margin-top: 40px;
	@media (max-width: ${BreakPoints.DESKTOPS}) {
		flex-wrap: wrap;
		gap: 16px;
		& > a {
			width: 100%;
			display: block;
		}
	}
`;

export const Close = styled.div`
	position: absolute;
	top: 16px;
	right: 16px;
	cursor: pointer;
`;
